"use strict";
/**
 * This file is part of stream-ext' project.
 * @link     : https://zhaiyiming.com/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2022 TINYMINS.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.monitorClick = exports.dispatchLog = exports.setLogger = void 0;
const globalConfig = {
    clickMonitors: [],
};
const setLogger = (logger) => {
    globalConfig.logger = logger;
};
exports.setLogger = setLogger;
const fire = (config, eventId, $target, $currentTarget) => {
    const logger = globalConfig.logger ||
        window.log;
    if (!logger) {
        return;
    }
    try {
        if (config && eventId !== void 0) {
            const selectors = [];
            let $parent = $target || null;
            while ($parent) {
                const id = $parent.id ? `#${$parent.id}` : '';
                const className = typeof $parent.className === 'string'
                    ? `.${$parent.className.replace(/ /giu, '.')}`
                    : '';
                selectors.unshift(`${$parent.tagName.toLowerCase()}${id}${className}`);
                $parent = $parent.parentElement;
            }
            const selector = selectors.join('>');
            const text = ($target === null || $target === void 0 ? void 0 : $target.textContent) || '';
            let params = [eventId, selector, text];
            if (config.transform) {
                params = config.transform({
                    target: $target || void 0,
                    currentTarget: $currentTarget || void 0,
                    config,
                }, params);
            }
            if (!params) {
                return;
            }
            logger(config.logType1, config.logType2, ...params);
        }
    }
    catch (error) {
        console.error(error);
    }
};
const dispatchLog = (propName, propValue, $el) => {
    let config;
    let eventId;
    for (const monitor of globalConfig.clickMonitors) {
        if (monitor.propName && monitor.propName === propName) {
            config = monitor;
            eventId = `prop:${monitor.propName}:${propValue}`;
            break;
        }
    }
    fire(config, eventId, $el, $el);
};
exports.dispatchLog = dispatchLog;
const onDOMClick = (e) => {
    const $target = e.target;
    if (!($target instanceof Element)) {
        return;
    }
    let config;
    let eventId;
    let $currentTarget = $target;
    // 逐级匹配 携带指定属性的 DOM 节点
    if (!config) {
        $currentTarget = $target;
        let isChild = false;
        while ($currentTarget) {
            for (const monitor of globalConfig.clickMonitors) {
                if (isChild && !monitor.acceptChild) {
                    continue;
                }
                const propValue = monitor.propName
                    ? $currentTarget.getAttribute(monitor.propName)
                    : null;
                if (monitor.propName && typeof propValue === 'string') {
                    config = monitor;
                    eventId = `prop:${monitor.propName}:${propValue || ''}`;
                    break;
                }
                if (config) {
                    break;
                }
            }
            if (config) {
                break;
            }
            if (!$currentTarget.parentElement) {
                break;
            }
            isChild = true;
            $currentTarget = $currentTarget.parentElement;
        }
    }
    // 逐级匹配 指定类型的 DOM 节点
    if (!config) {
        $currentTarget = $target;
        let isChild = false;
        while ($currentTarget) {
            for (const monitor of globalConfig.clickMonitors) {
                if (isChild && !monitor.acceptChild) {
                    continue;
                }
                if (monitor.tagName &&
                    $currentTarget.tagName.toUpperCase() === monitor.tagName.toUpperCase()) {
                    config = monitor;
                    eventId = `tag:${monitor.tagName.toLowerCase()}`;
                    break;
                }
                if (config) {
                    break;
                }
            }
            if (config) {
                break;
            }
            if (!$currentTarget.parentElement) {
                break;
            }
            isChild = true;
            $currentTarget = $currentTarget.parentElement;
        }
    }
    // 逐级匹配 通用默认埋点上报
    if (!config) {
        $currentTarget = $target;
        let isChild = false;
        while ($currentTarget) {
            for (const monitor of globalConfig.clickMonitors) {
                if (isChild && !monitor.acceptChild) {
                    continue;
                }
                if (monitor.propName === void 0 && monitor.tagName === void 0) {
                    config = monitor;
                    eventId = '*';
                    break;
                }
                if (config) {
                    break;
                }
            }
            if (config) {
                break;
            }
            if (!$currentTarget.parentElement) {
                break;
            }
            isChild = true;
            $currentTarget = $currentTarget.parentElement;
        }
    }
    fire(config, eventId, $target, $currentTarget);
};
const monitorClick = (monitors) => {
    globalConfig.clickMonitors = monitors;
    document.removeEventListener('click', onDOMClick);
    if (globalConfig.clickMonitors.length) {
        document.addEventListener('click', onDOMClick);
    }
};
exports.monitorClick = monitorClick;
